// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_DEMONS = [{
  id: 'demons_black_legion',
  factionId: FACTIONS.DEMONS,
  name: 'Чёрный легионер',
  priceNumens: 15000,
  skinRank: 1,
}, {
  id: 'demons_torchure',
  factionId: FACTIONS.DEMONS,
  name: 'Архитектор страданий',
  priceNumens: 45000,
  skinRank: 2,
}, {
  id: 'demons_fallen_angel',
  factionId: FACTIONS.DEMONS,
  name: 'Падший ангел',
  priceNumens: 90000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.ORANGE,
  ]
}, {
  id: 'demons_gold_legacy',
  factionId: FACTIONS.DEMONS,
  name: 'Владыка преисподней',
  priceNumens: 130000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'demons_ruby_legacy',
  factionId: FACTIONS.DEMONS,
  name: 'Огненный палач',
  priceCrystals: 200,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.RED,
  ],
  excludedFromChests: true
}];
